/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Products_Group_Levels_LedeInputs */



/**
* | output |
* | --- |
* | "XP counted from real activity, with rules you control." |
*
* @param {Products_Group_Levels_LedeInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const products_group_levels_lede = /** @type {((inputs?: Products_Group_Levels_LedeInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Products_Group_Levels_LedeInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("XP за настоящую активность — по правилам, которые задаёте вы.")
	return /** @type {LocalizedString} */ ("XP counted from real activity, with rules you control.")
});